/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'del-shared-in-progress',
  templateUrl: './in-progress.component.html',
})
export class InProgressComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
